/* eslint-disable tailwindcss/no-custom-classname */
import 'app/assets/scss/progress-bar.scss';

export const ProgressBar = () => (
  <div className="progress-bar">
    <div className="progress-bar-value" />
  </div>
);
